/** Context bindings — edit view (delegates to the shared form). */
import { ContextBindingForm } from "./_ContextBindingForm";

export function ContextBindingEdit() {
  return <ContextBindingForm action="edit" />;
}

export default ContextBindingEdit;
